import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag-color--sprite",
  "use": "flag-color--sprite-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-color--sprite\">\n<path d=\"M8.74167 2.04171L8.375 0.208374H0.125V15.7917H1.95833V9.37504H7.09167L7.45833 11.2084H13.875V2.04171H8.74167Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol